<template>
  <div>
    <div class="header">
      <h5 class="title">成绩查询</h5>
    </div>
    <div class="search-wrapper container">
      <a-alert
        :message="alertMessage"
        :type="alertType"
        style="max-width: 350px; margin: auto"
      ></a-alert>
      <br />
      <a-row type="flex" :gutter="40" align="middle" justify="center">
        <a-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
          <a-input
            size="large"
            addon-before="真实姓名"
            id="cert-name"
            placeholder="请输入姓名"
            v-model="queryParam.realname"
          />
          <a-input
            size="large"
            addon-before="身份证号"
            id="cert-idcard"
            placeholder="请输入身份证号"
            v-model="queryParam.idcard"
          />
        </a-col>
        <a-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
          <a-button style="height: 50px" type="primary" @click="onSearch()"
            >查询</a-button
          >
        </a-col>
      </a-row>
    </div>
    <div
      class="score-wrapper"
      id="score-wrapper"
      v-show="awardInfoList.length > 0"
    >
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>姓名</th>
            <th>活动</th>
            <th>参测项目</th>
            <th>参测级别</th>
            <th>试卷</th>
            <th>评定结果</th>
          </tr>
        </thead>
        <tbody id="score-data">
          <tr v-for="(scoreInfo, i) in awardInfoList" :key="i">
            <td>{{ scoreInfo.realname }}</td>
            <td>{{ scoreInfo.eventName }}</td>
            <td>{{ scoreInfo.eventParentCategory }}</td>
            <td>{{ scoreInfo.eventCategory }}</td>
            <td>
              {{ scoreInfo.paperName == null ? "" : scoreInfo.paperName }}
            </td>
            <td>{{ scoreInfo.scoreResult }}</td>
          </tr>
        </tbody>
      </table>
      <hr />
    </div>
    <!-- <div>
      <img
        src="/cert/qrcode.jpg"
        style="width: 200px; height: 200px; display: block; margin: 30px auto"
        alt=""
      />
      <h4 style="text-align: center; font-size: 18px">
        青少年人工智能核心素养测评公众号
      </h4>
    </div> -->
    <VerifyCodeModal ref="verifyCodeModal" />
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import QrCode from "@/components/tools/QrCode";
import { jumpMixins } from "@/utils/jumpMixins";
import { mixinDevice } from "@/utils/mixin.js";
import VerifyCodeModal from "@/components/common/VerifyCodeModal";

export default {
  name: "CertQuery",
  mixins: [mixinDevice, jumpMixins],
  components: {
    QrCode,
    VerifyCodeModal,
    VerifyCodeModal,
  },
  data() {
    return {
      awardInfoList: [],
      alertMessage: "请输入姓名+身份证查询证书。",
      alertType: "success",
      queryParam: {
        id: "",
        realname: "",
        idcard: "",
      },
    };
  },
  created() {
    let id = this.$route.query.id;
    if (id) {
      this.getAwardInfo(id);
    }
  },
  mounted() {},
  methods: {
    onSearch() {
      let that = this;
      this.$refs.verifyCodeModal.show(function () {
        that.getAwardInfo(
          that.queryParam.id,
          that.queryParam.realname,
          that.queryParam.idcard
        );
      });
    },
    getAwardInfo(eventApplyId, name, idcard) {
      if (!eventApplyId && !name && !idcard) {
        this.$message.info("请输入查询条件");
        return;
      }
      this.awardInfoList = [];
      getAction("/teaching/teachingEventApply/queryScore", {
        eventApplyId: eventApplyId,
        realname: name,
        idcard: idcard,
      }).then((res) => {
        if (res.success) {
          this.awardInfoList = res.result;
          this.alertMessage = `共查询到${this.awardInfoList.length}个成绩。`;
          for (let i in res.result) {
            let scoreInfo = res.result[i];
            scoreInfo.eventName = scoreInfo.eventName
              .replaceAll(" ", "")
              .replace(/\(.*?\)/g, "")
              .replace(/（.*?）/g, "");
            scoreInfo.eventParentCategory = scoreInfo.eventParentCategory
              .replaceAll(" ", "")
              .replace(/\(.*?\)/g, "")
              .replace(/（.*?）/g, "");
            scoreInfo.eventCategory = scoreInfo.eventCategory
              .replaceAll(" ", "")
              .replace(/\(.*?\)/g, "")
              .replace(/（.*?）/g, "");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
body {
  margin: auto;
}
.header {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  /* position: fixed; */
  z-index: 1100;
  top: 0px;
  left: auto;
  right: 0px;
  height: 64px;
  background-color: rgb(25, 118, 210);
  color: rgb(255, 255, 255);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.header .title {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 0em;
  margin: 16px 50px;
  color: white;
}
.search-wrapper {
  max-width: 1000px;
  margin: 50px auto;
  text-align: center;
}
.score-wrapper {
  max-width: 1500px;
  padding: 16px;
  border-width: 1px;
  border-style: dashed;
  border-image: initial;
  border-color: rgb(189, 189, 189);
  border-radius: 8px;
  margin: 20px auto;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  th {
    border: 1px solid #ddd;
    padding: 8px;
  }
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }
}
.table-bordered {
  border: 1px solid #ddd;
}
</style>